<template>
  <div class="view-cars">
    <Featured
      v-if="featuredCars.length > 0"
      :cars="featuredCars"
      :properties="featuredProperties"
      :auction="auction"
    />
    <Stripe :auctionStarts="auctionStarts" v-if="showStripe" />
    <Stripe2 v-if="false" />
    <b-container class="main-container">
      <b-row>
        <b-col class="main-content">
          <Grid :cars="cars" :auction="auction" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Featured from "../components/Featured";
import Stripe from "../components/Stripe";
import Stripe2 from "../components/Stripe2";
import Grid from "../components/cars/Grid";
import utils from "../assets/js/utils";

export default {
  name: "CarsView",
  components: {
    Featured,
    Stripe,
    Stripe2,
    Grid,
  },
  props: {
    auctionStarts: {
      type: String,
      required: true,
    },
    auction: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      cars: [],
      properties: [],
      featuredCars: [],
      featuredProperties: {},
      now: Math.trunc(new Date() / 1000),
    };
  },
  created: async function () {
    this.cars = await utils.loadCars(this);
    this.properties = await utils.loadProperties(this);

    this.featuredCars = this.getFeaturedCars();
    this.featuredProperties = this.getProperties(this.featuredCars);
  },
  methods: {
    getFeaturedCars: function () {
      return this.cars.filter(function (car) {
        return car.featured === true
          && car.pictures_main;
      });
    },
    getProperties: function (cars) {
      let indexedProperties = {};
      cars.forEach((car) => {
        indexedProperties[car.id] = this.properties.filter(function (property) {
          return property.car_id === car.id;
        });
      });
      return indexedProperties;
    },
  },
  computed: {
    dateInMilliseconds() {
      const date = this.auctionStarts.split(/[^0-9]/);
      return Math.trunc(
        new Date(
          date[0],
          date[1] - 1,
          date[2],
          date[3],
          date[4],
          date[5]
        ).valueOf() / 1000
      );
    },
    dateNow() {
      return this.now;
    },
    showStripe() {
      // Show 4 hours into the auction
      return this.dateInMilliseconds > (this.now - 1000 * 60 * 4);
    },
  },
};
</script>

<style lang="scss" scoped></style>
